import { Color } from '../theme/types/color'

/**
 * Genera una paleta de colores para gráficas usando los colores del tema del proyecto.
 * Selecciona colores vibrantes y contrastantes apropiados para visualizaciones de datos.
 * 
 * @param colors - Objeto de colores del tema (obtenido de useContextState)
 * @returns Array de colores en formato hexadecimal
 */
export const generateChartPalette = (colors: Color): string[] => {
  return [
    colors.color1,  // #3A87D9 - Azul principal
    colors.color8,  // #31C462 - Verde
    colors.color2,  // #9F31F6 - Morado
    colors.color4,  // #24A9E2 - Azul claro
    colors.color29, // #E87F10 - Naranja
    colors.color12, // #EC6666 - Rojo
    colors.color30, // #D93AD4 - Magenta
    colors.color42, // #24AAE3 - Azul cielo
    colors.color34, // #E88C10 - Naranja medio
    colors.color40, // #B647E6 - Morado claro
    colors.color41, // #A031F5 - Morado medio
    colors.color24, // #7024E2 - Morado oscuro
    colors.color7,  // #3356C0 - Azul oscuro
    colors.color47, // #B6B82F - Verde amarillento
    colors.color11, // #0062FF - Azul intenso
  ]
}

/**
 * Obtiene un color de la paleta de gráficas por índice.
 * Si el índice excede la longitud de la paleta, rotará cíclicamente.
 * 
 * @param colors - Objeto de colores del tema
 * @param index - Índice del color deseado
 * @returns Color en formato hexadecimal
 */
export const getChartColorByIndex = (colors: Color, index: number): string => {
  const palette = generateChartPalette(colors)
  return palette[index % palette.length]
}

/**
 * Obtiene un color basado en un porcentaje de score.
 * Útil para badges y elementos que indican rendimiento.
 * 
 * @param score - Porcentaje de score (0-100)
 * @returns Color en formato hexadecimal
 */
export const getScoreColor = (score: number, colors: Color): string => {
  if (score >= 81) return colors.color8  // Verde - #31C462
  if (score >= 61) return colors.color29 // Naranja - #E87F10
  return colors.color12 // Rojo - #EC6666
}
